import request from "@utils/request";

/**
 * 课程相关
 * @param data object 用户账号密码
 */
export  function queryLessonList(data) {
    return request.get("/lesson/queryLessonList", data, {login: false});
}

export function submitLession(data) {
    return request.get("/lesson/submitLesson", data, {login: false});
}

export function userRanking() {
    return request.get("/integra/userRanking", null, {login: false});
}

export function qryBillboard() {
    return request.get("/integra/billboard", null, {login: false});
}
export  function delLesson(data) {
    return request.get("/lesson/delLesson", data, {login: false});
}

export  function queryOldPeriodList(data) {
    return request.get("/lesson/queryOldPeriodList", data, {login: false});
}

export  function queryOldPeriodListByPage(data) {
    return request.get("/lesson/queryOldPeriodListByPage", data, {login: false});
}

export  function queryCTEjSysNoticeList(data) {
    return request.get("/lesson/queryCTEjSysNoticeList", data, {login: false});
}

export  function getNoticeList(data) {
    return request.get("/lesson/getNoticeList", data, {login: false});
}
